import React from "react";
import { BsGithub, BsInstagram, BsLinkedin } from "react-icons/bs";

const SocialMedia = () => (
  <div className="app__social z-10">
    <a 
      href="https://github.com/lovishtater" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <div>
        <BsGithub />
      </div>
    </a>
    <a 
      href="https://www.linkedin.com/in/lovishtater/" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <div>
        <BsLinkedin />
      </div>
    </a>
    <a 
      href="https://www.instagram.com/lovishtater/" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <div>
        <BsInstagram />
      </div>
    </a>
  </div>
);

export default SocialMedia;
